import { DataBean } from "../DataBean";

export class CashReimbursementCreate extends DataBean {



    public async createCashReimbursementAdjustment(idCashDeskAccount:any,documentLocation:any,documentDate:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.cashreimbursement.CashRequestItem_createCashReimbursementAdjustment_Number_Number_java.util.Date_Number", [idCashDeskAccount,documentLocation,documentDate,idEmployee]);
    }
    
}